<template>
  <article>
    <div class="product-img">
      <div class="product-price">
        <div class="price-container">
          <!-- <span class="product-new">new</span> -->
          <div class="price-wrapper">
            <div class="price-section">
              <span class="price-without-tax">
                ${{ product.productPrice | currencyFormat }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <a target="_blank" :href="product.jumpLink" @click="handleProductClick(product)">
        <el-image
          class="image"
          :src="product.productImage"
          v-loading="imgStatus"
          @load="complete"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </a>
    </div>
    <div class="product-description">
      <h4 class="product-description_title">
        <a
          :href="product.jumpLink"
          target="_blank"
          @click="handleProductClick(product)"
          >{{ product.productDesc }}</a
        >
      </h4>
      <span class="product-description_serial"
        >{{ product.productSku }}</span
      >
    </div>
  </article>
</template>

<script>
import { productsClick } from "@/api/table";
export default {
  name: "card",
  props: {
    product: Object,
    imgUrl: String,
    searchParams: Object
  },
  data() {
    return {
      currentDate: new Date(),
      imgStatus: true,
      params: {
        year: '',
        make: '',
        model: '',
        productSku: ''
      }
    };
  },
  mounted() {
    this.params.year = Number(this.searchParams.year)
    this.params.make = this.searchParams.make
    this.params.model = this.searchParams.model
  },
  methods: {
    complete() {
      this.imgStatus = false;
      // console.log("loading complete");
    },
    // 点击product时记录点击次数
    handleProductClick(product) {
      this.params.productSku = product.productSku
      productsClick(this.params).then(res => {
        if (res.resultStatus) {
          console.log("product点击了一次")
        }
      });
    }
  },
  filters: {
    currencyFormat: function(value) {
      return value / 100;
    }
  }
};
</script>
<style lang="less">
article {
  /*border: black !important;*/
  border-radius: 0px !important;
  max-width: 250px;
  position: relative;
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  flex: 1 1 auto;
  margin: 0 auto 30px;
  /*background-color: rgba(50, 50, 50, 0.7) !important;*/
  background-color: #ffffff!important;
  box-sizing: border-box;
  border: 1px solid transparent;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .15);
  transition: all .3s ease;

  &:hover {
    border-color: #e00007;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .15);

    .product-price {
      background-color: #e00007;
    }
  }


  .product-description {
    text-align: left;
    box-sizing: border-box;
    line-height: 1.4;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    padding: 10px;
    position: relative;

    &_title {
      cursor: pointer;
      margin-bottom: 0;
      font-size: 15px;
      font-weight: 700;
      font-style: normal;
      line-height: 18px;
      text-align: left;
      color: #000;
      letter-spacing: 0;
      font-family: inherit;
      margin-top: 0;
      a {
        color: inherit;
      }
    }
    &_serial {
      padding-top: .29412rem;
      color: #676767;
      font-size: 0.70588235rem;
      font-weight: 200;
      line-height: 18px;
      font-style: italic;
      text-transform: uppercase;
    }
  }

  .product-img {
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-price {
    z-index: 1;
    font-size: 13px;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: -15px;
    font-weight: 700;
    transform: skew(-15deg);
    background-color: #4e4e4e;
    transition: all .3s ease;
    font-style: normal;
    .price-container {
      transform: skew(15deg);
      margin-left: 15px;
      position: relative;
      overflow: hidden;
      box-sizing: border-box;
      color: #fff;
      .product-new {
        padding: 0.58823529rem 1rem;
        position: absolute;
        background-color: #3c78ff;
        color: #fff;
        font-size: 0.70588235rem;
        text-transform: uppercase;
        text-align: center;
        font-weight: 200;
        font-style: italic;
        line-height: 0;
        -webkit-transform: translateY(25%) rotate(-90deg);
        transform: translateY(25%) rotate(-90deg);
        top: 15%;
        left: -50%;
        z-index: 1;
        width: 100%;
        margin-left: 0.58823529rem;
      }
      .price-wrapper {
        padding: 0.29412rem 0.58824rem;
        // padding-left: 1.76470588rem;
        .price-section {
          color: #605f5f;
          span {
            color: #fff;
          }
        }
      }
    }
  }

  .image {
    display: block;
    margin: auto;
    width: unset;
    max-width: 50rem;
    height: unset;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

article {
  @media (min-width: 600px) {
    .price-container .product-new {
      top: 25% !important;
    }
    .product-description {
      padding: 20px;
    }
    .product-price {
      font-size: 1.47058824rem;
    }
  }
  @media (max-width: 550px) {
    .price-wrapper {
      // padding-left: 1.76470588rem !important;
    }
    .product-description {
      color: #000;
      background-color: #ffffff;
      text-align: left;
    }

    .product-new {
      // transform: translateY(-50%) rotate(-90deg) scale(0.85);
      // transform: translateY(25%) rotate(-90deg) scale(0.85) !important;
      // margin-left: 0.50rem !important;
    }
    .price-container {
      position: relative;
      margin-left: 15px;
      overflow: hidden;
      transform: skew(15deg);
      line-height: 1.5;
    }
    .image {
      display: block;
    }
  }
}
</style>
